import { render, staticRenderFns } from "./FoodInfo.vue?vue&type=template&id=20c9a113&scoped=true&"
import script from "./FoodInfo.vue?vue&type=script&lang=js&"
export * from "./FoodInfo.vue?vue&type=script&lang=js&"
import style0 from "./FoodInfo.vue?vue&type=style&index=0&id=20c9a113&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c9a113",
  null
  
)

export default component.exports